import { render, staticRenderFns } from "./McAnswer.vue?vue&type=template&id=a923ebf0&scoped=true&"
import script from "./McAnswer.vue?vue&type=script&lang=js&"
export * from "./McAnswer.vue?vue&type=script&lang=js&"
import style0 from "./McAnswer.vue?vue&type=style&index=0&id=a923ebf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923ebf0",
  null
  
)

export default component.exports